module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/bicycle-ae6e02a8af28a1b1854a42332973972d.svg";